import { Injectable } from '@angular/core';
import { BaseDAO } from './baseDAO';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { CalendarPreferences } from 'anchor-shared/lib/model/entity/calendarPreferences';

@Injectable()
export class CalendarPreferencesDAO extends BaseDAO<CalendarPreferences> {
  constructor(public readonly apiHelper: ApiHelper) {
    super(apiHelper, ConstantMan.API.RESOURCE.VESSEL_CALENDAR_PREFERENCES);
  }

  public createNewPreference(
    partialCalendarPreferences: Partial<CalendarPreferences>,
  ): Observable<any> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/' +
      partialCalendarPreferences.vesselId +
      '/';
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any[]>(
      url,
      method,
      null,
      partialCalendarPreferences,
      headers,
    );
  }

  public updateFromPartial(
    id: number,
    partialCalendarPreferences: Partial<CalendarPreferences>,
    vesselId: number,
  ): Observable<any> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/' +
      vesselId +
      '/partial/' +
      id;
    const method = 'PUT';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any[]>(
      url,
      method,
      null,
      partialCalendarPreferences,
      headers,
    );
  }

  public deleteById(vesselId: number, id: number): Observable<any> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/' +
      vesselId +
      '/' +
      id;
    const method = 'DELETE';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any[]>(url, method, null, null, headers);
  }

  public deleteAllGoogleCalsByVesselId(vesselId: number): Observable<any> {
    let url: string = `${this.apiHelper.getServiceName()}${this.getResource()}/${vesselId}/remove-google-calendar`;
    const method = 'DELETE';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any[]>(url, method, null, null, headers);
  }

  public checkIfDateExists(
    vesselId: number,
    calendarPreferencesDate: { startDate: string; endDate: string },
  ): Observable<{ conflict: boolean }> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/' +
      vesselId +
      '/check-date';
    const method = 'PUT';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<{ conflict: boolean }>(
      url,
      method,
      null,
      calendarPreferencesDate,
      headers,
    );
  }
}
